import { ShiftTemplate } from '../types/ShiftTemplate';
import { fetchFromApi } from '@agyletime/vue-3-common/src/utils/apiService';

export async function getShiftTemplatesAndExtractData(): Promise<{ shiftTemplates: ShiftTemplate[] }> {
    const shiftTemplates: ShiftTemplate[] = await fetchFromApi('/api/schedule/configuration/shiftTemplates');
    return { shiftTemplates: shiftTemplates.sort((a, b) => a.name.localeCompare(b.name)) };
}